<template>
  <div class="ArticleBodyStyles">
    <slot></slot>
  </div>
</template>

<style scoped>

.ArticleBodyStyles {
  font-weight: 400;
  font-size: var(--font-size-3);
  line-height: 1.75;
  color: var(--text-color-dark);
}

.ArticleBodyStyles:deep(h1),
.ArticleBodyStyles:deep(h2),
.ArticleBodyStyles:deep(h3),
.ArticleBodyStyles:deep(h4),
.ArticleBodyStyles:deep(h5),
.ArticleBodyStyles:deep(h6) {
  color: var(--text-color-black);
  font-weight: 600;
  line-height: 1.2;
  margin-top: var(--spacing-10);
}
.ArticleBodyStyles:deep(h1) {
  font-size: var(--font-size-9);
}
.ArticleBodyStyles:deep(h2) {
  font-size: var(--font-size-7);
}
.ArticleBodyStyles:deep(h3) {
  font-size: var(--font-size-6);
}
.ArticleBodyStyles:deep(h4) {
  font-size: var(--font-size-5);
}
.ArticleBodyStyles:deep(h5) {
  font-size: var(--font-size-4);
}
.ArticleBodyStyles:deep(h6) {
  font-size: var(--font-size-3);
}

.ArticleBodyStyles:deep(p),
.ArticleBodyStyles:deep(ul),
.ArticleBodyStyles:deep(ol) {
  margin: var(--spacing-7) 0;
}

.ArticleBodyStyles:deep(strong) {
  font-weight: 600;
}

.ArticleBodyStyles:deep(ul),
.ArticleBodyStyles:deep(ol) {
  padding-left: 1.5rem;
  line-height: 1.5;
}
.ArticleBodyStyles:deep(ul) {
  list-style: disc;
}
.ArticleBodyStyles:deep(ol) {
  list-style: decimal;
}

.ArticleBodyStyles:deep(ul li),
.ArticleBodyStyles:deep(ol li) {
  margin: 1.5rem 0;
}

.ArticleBodyStyles:deep(a:not(.CtaLink)) {
  font-weight: 500;
  color: var(--brand-color);
  text-decoration: underline;
  transition: all 0.15s;
}

.ArticleBodyStyles:deep(a:not(.CtaLink):hover) {
  color: var(--text-color-black);
}

.ArticleBodyStyles:deep(blockquote) {
  margin: var(--spacing-11) 0;
  background-color: var(--bg-color-pale-blue);
  background-image: url('../../../assets/ui/quote-translucent.svg');
  background-repeat: no-repeat;
  background-position: var(--spacing-10) var(--spacing-10);
  background-size: 50px auto;
  border-radius: 6px;
  padding: calc(var(--spacing-10) + 60px) var(--spacing-10) var(--spacing-12);
}

@media (--screen-md) {

  .ArticleBodyStyles:deep(blockquote) {
    background-size: 70px auto;
    padding: var(--spacing-10) var(--spacing-10) var(--spacing-10) calc(var(--spacing-10) + 100px);
  }
}
</style>
